import { Timestamp } from "@firebase/firestore";
import { PlacementType } from ".";

/**
 * Firestore events 컬렉션의 Event 문서 인터페이스
 */
export interface Event {
  eventId: string;
  title: string;
  uploadType: 'zip' | 'url';
  content: string; // HTML 내용이 포함될 수 있으므로 string 타입으로 정의
  type: EventType;
  startDate: Timestamp;
  endDate: Timestamp;
  bannerImageUrl: string | null;
  isPublic: boolean;
  placement: PlacementType | null;
  order: number | null;
  isPopup: boolean;
  allowedUsers: string[] | null; // isPublic이 false일 때만 사용
  allowedEnterprises: string[] | null; // isPublic이 false일 때만 사용
  createdAt: Timestamp;
}

/**
 * Event 컬렉션 경로 상수
 */
export const EVENT_COLLECTION = process.env.REACT_APP_EVENT_COLLECTION as string;


export enum EventType {
  ENTRY = 'entry',
  SURVEY = 'survey',
  MISSION = 'mission',
} 

export interface EventSignUp {
  id: string;
  consentMarketing: boolean;
  email: string;
  eventId: string;
  eventType: string;
  name: string;
  phone: string;
  timestamp: Timestamp;
  uid: string;
}

export const EVENT_SIGNUP_COLLECTION = process.env.REACT_APP_EVENT_SIGNUP_COLLECTION as string;


export interface EventStats {
  eventId: string;
  name: string;
  participantCount: number;
  uniqueParticipants: number; // Count unique users
  marketingConsentCount: number; // Users who consented to marketing
  latestSignUpDate: Timestamp | null;
  startDate: Timestamp;
  endDate: Timestamp;
  isPublic: boolean;
}